import type { MapperImageOptions } from '~/types'
import { mapperGlobalDataTheme } from '../../../../core/data-layer/global-data/mappers'
import {
  mapperModuleMedia,
  mapperModuleNavigationLink,
  mapperModuleVideo
} from '../../../../core/data-layer/modules/mappers'

/**
 * Block quote mapper
 * @param {Object} data - cms response data
 * @param {Object} options - options
 * @return {Object} the normalized data
 */
export default (data, options) => {
  if (!data) {
    return null
  }

  const { getUrl } = options

  const imageOptions: MapperImageOptions = {
    sizes: {
      small: { width: 336, height: 736, aspectRatio: null },
      medium: { width: 330, height: 586, aspectRatio: '9/16' },
      large: { width: 336, height: 597, aspectRatio: '9/16' }
    }
  }

  return {
    id: data.sys?.id || '',
    subtitle: data.subtitle || '',
    title: data.title || '',
    author: data.author || '',
    authorInfo: data.authorInfo || '',
    image: data.media?.contentType === 'ModuleMedia' ? mapperModuleMedia(data.media, imageOptions) : null,
    video:
      data.media?.contentType === 'ModuleVideo' || data.media?.contentType === 'ModuleInternalVideo'
        ? mapperModuleVideo(data.media, options)
        : null,
    theme: mapperGlobalDataTheme(data.theme)?.theme || null,
    link: mapperModuleNavigationLink(data.link, getUrl)
  }
}
